"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _QuestionContainer = require("../QuestionContainer");

var _QuestionContainer2 = _interopRequireDefault(_QuestionContainer);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _QuestionText = require("../QuestionText");

var _QuestionText2 = _interopRequireDefault(_QuestionText);

var _Slider = require("@material-ui/core/Slider");

var _Slider2 = _interopRequireDefault(_Slider);

var _useQuestionAnswer = require("../../hooks/use-question-answer");

var _useQuestionAnswer2 = _interopRequireDefault(_useQuestionAnswer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Row = _styledComponents2.default.div`
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
`;

exports.default = ({
  question,
  onChangeAnswer
}) => {
  const [{
    answer,
    error
  }, changeAnswer] = (0, _useQuestionAnswer2.default)(question, onChangeAnswer, question.defaultAnswer || undefined);
  const {
    rateValues,
    rankings,
    minRateDescription,
    maxRateDescription,
    midRateDescription
  } = question;
  return _react2.default.createElement(_QuestionContainer2.default, {
    question: question,
    answered: answer !== undefined,
    error: error
  }, _react2.default.createElement(_Slider2.default, {
    onChange: (e, value) => changeAnswer(value),
    style: {
      opacity: answer === undefined ? 0.5 : 1,
      marginTop: 10
    },
    value: answer === undefined ? rateValues ? rateValues[Math.floor(rateValues.length / 2)] : 2 : answer,
    min: 0,
    max: rankings - 1 || rateValues ? rateValues[rateValues.length - 1] : 4,
    step: 1
  }), rateValues ? _react2.default.createElement(Row, null, rateValues.map(r => _react2.default.createElement(_QuestionText2.default, {
    key: r
  }, r))) : _react2.default.createElement(Row, null, _react2.default.createElement(_QuestionText2.default, null, minRateDescription), midRateDescription && _react2.default.createElement(_QuestionText2.default, null, midRateDescription), _react2.default.createElement(_QuestionText2.default, null, maxRateDescription)));
};